import * as React from 'react';
import { RCUtils } from './../../RCUtils';
import { PopupWindow } from './PopupWindow';
import $ from 'jquery';
import MultiSelectListBox from 'react-multiselect-listbox';
import UserRights from './../../../src/actions/UserRights';
import { AssetSearch } from './../../../src/actions/CCWizardEmpties';  //'../../actions/CCWizardEmpties.js'
import forIn from 'lodash/forIn';
var Config: any = require('../../Config.json');

export interface SearchControlsPreference {
    selectedSearchControls: any;
}
var self;
var hasReefers: boolean = false;
var hasGensets: boolean = false;
var hasDrys: boolean = false;
var hasChassis: boolean = false;
var assetCount = 0;
var showOem: boolean = false;
var showInvState: boolean = false;

export class SearchPreferenceControl extends React.Component<any, SearchControlsPreference> {
    constructor(props: any) {
        super(props);
        this.state = {
            selectedSearchControls:[]
        };
        assetCount = 0;
        var customer = JSON.parse(sessionStorage.getItem('customerDetails'));
        if (customer != null && customer != undefined) {
            if (customer.HasReefer && customer.GroupsRights.includes('Reefers')) {
                assetCount += 1;
                showOem = true;
                showInvState = true;
                hasReefers = true;
            }
            if (customer.HasGenset && customer.GroupsRights.includes('Gensets')) {
                assetCount += 1;
                showOem = true;
                hasGensets = true;
            }
            if (customer.HasDry && customer.GroupsRights.includes('Dry')) {
                assetCount += 1;
                showInvState = true;
                hasDrys = true;
            }
            if (customer.HasChassis && customer.GroupsRights.includes('Chassis')) {
                assetCount += 1;
                hasChassis = true;
            }
        }
        self = this;

    }
    getSearchControls = () => {
        let options = [];
        var cargoCareProfileRight = UserRights.checkMenuItemVisibility('247')[0];
        forIn(AssetSearch, function (value, key) {
            if (((cargoCareProfileRight == "hidden") && key == "CargoCareProfile")
                || (!hasReefers && key == "BookingNumber")
                || (assetCount == 1 && key == "AssetTypes")
                || (!showOem && key == "OEM")
                || (!showInvState && key == "InventoryState")
            ) {
                // dont push 
            }
         else{
            options.push({desc: value, value:key})
             }
        });
        
        return options;
    };
    componentDidMount() {
        this.LoadSavedSearchItems();
    }
    LoadSavedSearchItems() {
        $('#globalLoader').show();
        var dashboardPreferenceId: any = sessionStorage.getItem('DashboardPreferenceId');
        var url = Config.ApiBaseUrl + '/api/User/GetUserSearchControlsPreference?dashboardPreferenceId='+dashboardPreferenceId;
        var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                if (data == "") {
                    let optionsArray = this.getSearchControls();
                    let Initialdata = optionsArray.map(i => i.value);
                    this.setState({ selectedSearchControls: Initialdata }, () => { $('#globalLoader').hide() });
                }
                else {
                   if(UserRights.checkMenuItemVisibility('247')[0] == "hidden")
                    {
                     const index = data.indexOf('CargoCareProfile');
                            if (index > -1) { 
                                    data.splice(index, 1);
                                }                    
                    }
                   this.setState({ selectedSearchControls: data }, () => { $('#globalLoader').hide() });                  
                }
            });
    }

    componentWillReceiveProps() {
            this.LoadSavedSearchItems();
    } 

    handleCancel() {
         ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
    }
    handleResetSearchPreferences() {
        this.setState({
            selectedSearchControls: this.getSearchControls().map(i => i.value)
        })
    }

      handleSaveSearchPreferences() {
                if (self.state.selectedSearchControls.length == 0)
                    {
                        PopupWindow.showErrorMessage("Alert", "Please select at least one search field to save search preference.");
                    }
                else {
                        this.onSubmit();
                     }
                        
            }
       onSubmit() {
        if (self.state.selectedSearchControls.length > 0) {
            $('#globalLoader').show();
            var dashboardPreferenceId: any = sessionStorage.getItem('DashboardPreferenceId');
            var url = Config.ApiBaseUrl + '/api/User/SaveSearchPreference';
            var SearchPreferenceData: any = { DashboardPreferenceId : dashboardPreferenceId, SelectedSearchControls: self.state.selectedSearchControls };
            var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(SearchPreferenceData), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(data => {
                    //Save and Close 
                    this.props.saveAndCloseSearchPreferenceDialog();                   
                });                            
        }
        else
            PopupWindow.showErrorMessage("Alert", "Please select at least one search field to save search preference.");
    }
    
    public render() {
        return <div>
            <div>
                <div className='container_text'>
                    <span className='fields_Show'>Fields to Show</span>

                    <span className='fields_hide'> Fields to Hide </span>

                </div>
                <div className="container">

                    <MultiSelectListBox 
                        className={"multi-select"}
                        overrideStrings={{
                            search: "Search...",
                            selectAll: "Add All (>>)",
                            removeAll: "Remove All (<<)",
                            selectedInfo: "Selected Search Fields"
                        }}
                        sortable={true}
                        options={this.getSearchControls()}
                        textField="desc"
                        valueField="value"
                        value={this.state.selectedSearchControls}
                        rowHeight={50}
                        onSelect={({ item, sortedList }) => {                   
                            this.setState({ selectedSearchControls: sortedList.map(i => i.value) });
                        }}
                        onRemove={({ item }) => {
                            if(item.value == "AssetID")
                                {
                                PopupWindow.showErrorMessage("Alert", " 'Asset Id' is mandatory and cannot be moved.");
                                return;
                                }
                            else{
                                this.setState({ selectedSearchControls: [...this.state.selectedSearchControls.filter(i => i !== item.value)] });
                                }
                        }}
                        onSelectAll={selectedItems => {
                            const selected = [
                                ...this.state.selectedSearchControls,
                                ...selectedItems.map(item => item.value)
                            ];
                            this.setState({
                                selectedSearchControls: selected
                            })
                        }}
                        onRemoveAll={() => {                          
                            this.setState({
                                selectedSearchControls: ['AssetID']
                            })
                        }}
                        onSort={({ sortedList }) =>
                            this.setState({
                        selectedSearchControls: [...sortedList.map(i => i.value)]
                        })
                    }
                
                    />
                </div>
            </div>

            <div className="modal-footer mt-2">
                <button type="button" onClick={this.handleCancel.bind(this)} className="btn btn-secondary" >Cancel</button>
                <button type="button" onClick={this.handleResetSearchPreferences.bind(this)} className="btn btn-primary" >Reset</button>
                <button type="button" onClick={this.handleSaveSearchPreferences.bind(this)} className="btn btn-primary" >Save</button>
              
              
            </div>
        </div>;
    }
}


